import { AdDisplayMode } from '@shared/enums/AdDisplayMode';
import { AdRotationMode } from '@shared/enums/AdRotationMode';

export function getEffectiveCreativeRotationMode(displayMode, rotationMode, creativeCount) {
	if (displayMode === AdDisplayMode._10S_ONCE && creativeCount > 1) {
		// Once-per-reload only has one display slot. Sequential order would always pick the first creative, so rotate randomly across player loads.
		return AdRotationMode.RANDOMIZED;
	}

	return rotationMode || AdRotationMode.SEQUENTIAL;
}
